
export default function setStateAsync(newState,setState,mounted){
    if(mounted)
        setState(newState)
}